import Route from '@ember/routing/route';
import { service } from '@ember/service';
import JournalContactInfo from 'donor-elf-web/lib/models/journal-contact-info';
import JournalInfo from 'donor-elf-web/lib/models/journal-info';
import JournalService from 'donor-elf-web/services/journal-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import { type JournalParams } from '../journal';

export interface JournalSegmentsRouteModel {
  journalInfo: JournalInfo;
  journalContactInfos: JournalContactInfo[];
}

export default class JournalsSegmentsRoute extends Route {
  @service declare journalService: JournalService;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Journal Segments';
  }

  async model() {
    await this.journalService.load();
    let journalId = (
      this.paramsFor('funds.fund.journals.journal') as JournalParams
    ).journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    let journalContactInfos =
      await this.journalService.loadJournalContactInfos(journalId);
    return {
      journalInfo,
      journalContactInfos,
    };
  }
}
